export const refreshIframeDataKey = data => {
	try {
		const cloned = JSON.parse(JSON.stringify(data || {}));
		cloned._key = Date.now() + Math.floor(Math.random() * 1000000);
		const menus = cloned?.pageMenuVOS;
		if (Array.isArray(menus)) {
			menus.forEach(menu => {
				if (Array.isArray(menu?.moduleVOS)) {
					menu.moduleVOS.forEach(mod => {
						// 确保组件强制重载
						mod._key = Date.now() + Math.floor(Math.random() * 1000000);
					});
				}
			});
		}
		return cloned;
	} catch (err) {
		return data;
	}
};
